import styled from 'styled-components';
import * as palette from 'config';

export const FlexContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    white-space: pre-wrap;
    width: 100%;
    overflow: hidden;
`;

export const ScrollableFlexContainer = styled(FlexContainer)`
    overflow-y: scroll;
`;

export const PageHeightFlexContainer = styled(FlexContainer)`
    height: calc(100vh - ${palette.HEADER_SIZE});
`;
